import { Arrange, Button, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./OAuthOidcNotFound.styles";

interface Props {
  onSignInClick: () => void;
}

const OAuthOidcNotFound = ({ onSignInClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Arrange
      isVertical
      alignment="center"
      gap="medium"
      data-testid="oidc-not-found"
      customCss={styles.wrapper}
    >
      <Typography variant="h1" isMarginless>
        {t(l.oauthSignUp.notFound.title)}
      </Typography>
      <Typography variant="body" isMarginless>
        {t(l.oauthSignUp.notFound.message)}
      </Typography>
      <Button onClick={onSignInClick} variant="primary">
        {t(l.oauthSignUp.notFound.signInCta)}
      </Button>
    </Arrange>
  );
};

export { OAuthOidcNotFound };
